import { fetchOptions } from '@edsn/api-idm-bff';
import { oidcUserProfileWithAssignedRolesSchema } from '@edsn/auth/oidc-profile-schema';
import { oidcSpa } from 'oidc-spa/react-spa';
import { getConfig } from './utils/config';

export const {
  bootstrapOidc,
  useOidc,
  getOidc,
  enforceLogin,
  // Wrap your all application within this component in src/main.tsx
  // Non blocking rendering is possible, see: https://docs.oidc-spa.dev/v/v10/features/non-blocking-rendering#react-spas
  OidcInitializationGate,
} = oidcSpa
  .withExpectedDecodedIdTokenShape({
    // Describe the expected shape of the ID Token.
    // Think of `decodedIdToken` as your “user” object.
    // If you’re unsure what fields are available, open the console:
    // oidc-spa will log the decoded token for you.
    decodedIdTokenSchema: oidcUserProfileWithAssignedRolesSchema,
  })
  .createUtils();

const config = getConfig();
let initializeOidcPromise: Promise<void> | undefined;

/**
 * Initialize OIDC after the mock service worker is ready.
 */
export function initializeOidc() {
  if (initializeOidcPromise) {
    return initializeOidcPromise;
  }

  initializeOidcPromise = (async () => {
    const shouldEnableDebugLogs =
      globalThis.localStorage?.getItem('oidc-debug-logs') === 'true';

    await bootstrapOidc({
      implementation: 'real',
      issuerUri: config.idpUrl,
      clientId: config.clientId,
      debugLogs: shouldEnableDebugLogs,
      sessionRestorationMethod: 'full page redirect',
      scopes: [
        'openid',
        'profile',
        'email',
        'roles',
        'fr:idm:*',
        'token_v2',
        'edsn',
        'assigned_organization_roles',
      ],
    });
  })();

  return initializeOidcPromise;
}

fetchOptions.getToken = async (): Promise<string> => {
  const oidc = await getOidc();
  if (oidc.isUserLoggedIn) {
    return oidc.getAccessToken();
  }

  throw new Error('User is not logged in');
};

fetchOptions.baseUrl = config.apiUrl;
